// Generated by https?://quicktype.io
export namespace InternalBroker {
    export interface Agent {
        id?: string;
        default_trading_group?: string;
        leverage_restriction?: boolean;
        affiliate_id?: string;
        targets_linked_count?: number;
    }

    export interface AgentReferrals {
        trading_account_number?: string;
        account_linked?: string;
        users_linked?: TargetUserLinked[];
        agent_number?: string;
    }

    export interface TargetUserLinked {
        id?: string;
        email: string;
    }
}
